import { GeoLocation, User, UserDetailedInfo, UserInterest } from "@/types";

import { axios } from "../axios.instance";

export type UpdateMeRequest = Partial<User & Omit<UserDetailedInfo, "interests">> & {
  currentLocation?: Omit<GeoLocation, "label">;
  interests?: UserInterest["id"][];
};

export type UpdateMeResponse = User & UserDetailedInfo;

export const updateMe = async (body: UpdateMeRequest): Promise<UpdateMeResponse> => {
  const { data } = await axios.patch("users/me/update", body);

  return data;
};
